import {ComponentProps} from "react";
import classNames from "classnames";
import {useAddToWaitList} from "../model/useAddToWaitList";
import {Svg} from "@/shared/ui/Svg";
import {Button} from "@/shared/ui/Button";
import styles from "./AddToWaitListButton.module.scss";

type Props = Omit<ComponentProps<typeof Button>, "loading" | "onClick"> & {
    productId: number;
    selectedSize?: string | null;
    iconClassName?: string;
};

export const AddToWaitListButton = (
    {productId, selectedSize, variant, className, labelClassName, iconClassName, children, ...buttonProps}: Props
) => {
    const {addToWaitList, loading} = useAddToWaitList();

    const buttonClasses = classNames(styles.button, className);
    const labelClasses = classNames(styles.label, labelClassName);
    const iconClasses = classNames(styles.icon, iconClassName);

    return (
        <Button
            {...buttonProps}
            loading={loading}
            variant={variant}
            className={buttonClasses}
            labelClassName={labelClasses}
            onClick={() => addToWaitList({productId, size: selectedSize})}
        >
            {variant === "icon" ? <Svg id={`waitList`} className={iconClasses} /> : children}
        </Button>
    );
};
